import { useTranslation } from 'react-i18next'

type Props = { multiplier: number; payout: number }

/** Display a confirmed personal result; never derive payout from the live curve. */
export function CashoutReceipt({ multiplier, payout }: Props) {
  const { t, i18n } = useTranslation()
  const points = new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(payout)
  return (
    <section className="cashout-receipt" data-cashout-receipt role="status" aria-live="polite" aria-atomic="true">
      <div className="cashout-receipt__heading">
        <span className="cashout-receipt__check" aria-hidden="true">✓</span>
        <strong>{t('collected')}</strong>
      </div>
      <div className="cashout-receipt__figures">
        <div><span>{t('receipt.points')}</span><strong data-collected-points>{points}</strong></div>
        <div><span>{t('receipt.multiplier')}</span><strong data-collected-multiplier>{multiplier.toFixed(2)}x</strong></div>
      </div>
      <p>{t('receipt.settled')}</p>
      {import.meta.env.VITE_DEMO_MODE === 'true' && <small>{t('receipt.noValue')}</small>}
    </section>
  )
}
